import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import { saveAs } from 'file-saver';
import { CsvToHtmlTable } from 'react-csv-to-table';
import PageTitle from '../../../components/PageTitle';
import RouteNames from '../../App/RouteNames';
import TitleFrom from '../../../components/common/TitleFrom';
import { OperatorTenantRecordLogSearchForm } from '../../../components/UsageHub';
import { DataTable, TablePagination, ModalWithItem, GenericInput } from '../../../components/common';
import {
  tabelColumnOperatorTenantRecordLog,
  sortOperatorTenantRecordLog,
  tabelColumnOperatorTenantRecordLogById,
} from '../constants';
import { searchTenantOperatorRecord, getTenantRecordById } from '../actions';
import { makeGetTenantOperatorRecord } from '../selectors';
import { getPageTotalCount, getBase64, splitF } from '../../../utils/utils';
import { makeGetS3Config } from '../../App/selectors';
import { readFileFromS3 } from '../../App/actions';

let fileSelect = null;
let pathSelect = null;
let idSelect = '';

class TenantRecordLog extends Component {
  state = {
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listOperatorTenantRecordLog: [],
    isOpenMdalDetails: false,
    itemDetails: [],
    pageItem: 0,
    sizeItem: 20,
    itemSelect: {},
    totalCountItem: null,
    base64File: null,
    isOpenMdalDownload: false,
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listOperatorTenantRecordLog: props.listOperatorTenantRecordLog,
      totalCount: getPageTotalCount({ ...state, items: props.listOperatorTenantRecordLog }),
    };
  }

  componentDidMount() {
    this.doSearchTenantOperatorRecord();
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doSearchTenantOperatorRecord();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doSearchTenantOperatorRecord());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doSearchTenantOperatorRecord());
  };

  onPageChangeItem = page => {
    const { pageItem } = this.state;
    if (pageItem === page) return '';
    this.setState({ pageItem: page }, () => this.doGetTenantRecordById());
  };

  onSizeChangeItem = size => {
    this.setState({ sizeItem: size, page: 0 }, () => this.doGetTenantRecordById());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doSearchTenantOperatorRecord();
    });
  };

  doSearchTenantOperatorRecord = () => {
    const { filter, page, size, sorted } = this.state;
    const { searchTenantOperatorRecord } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort: !isEmpty(sorted) ? sortOperatorTenantRecordLog[sorted.sortCol][sorted.sortDir] : null,
    };
    this.setState({ isSearching: true });
    searchTenantOperatorRecord(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doReadFileFromS3 = ({ config, path }) => {
    const { readFileFromS3 } = this.props;
    readFileFromS3({ ...config.data, url: path }, ({ success, data }) => {
      if (success) {
        fileSelect = data;
        pathSelect = path;
        this.handleFiles(data);
        getBase64(data, result => {
          this.setState({ base64File: result });
        });
      }
    });
  };

  downloadFile = path => {
    const { s3Config } = this.props;
    this.doReadFileFromS3({
      path,
      config: { data: s3Config },
    });
  };

  saveFileSelect = () => {
    saveAs(fileSelect, `${splitF(pathSelect)}`);
  };

  doGetTenantRecordById = (id, item) => {
    idSelect = id || idSelect;
    const { pageItem, sizeItem, totalCountItem, itemSelect } = this.state;
    const { getTenantRecordById } = this.props;
    const payload = {
      page: pageItem + 1,
      size: sizeItem,
      id: idSelect,
    };
    getTenantRecordById(payload, ({ success, data }) => {
      if (success) {
        this.setState({
          itemDetails: data,
          isOpenMdalDetails: true,
          itemSelect: item || itemSelect,
          totalCountItem: getPageTotalCount({
            totalCount: totalCountItem || data.length,
            size: sizeItem,
            page: pageItem,
            items: data,
          }),
        });
      } else {
        this.setState({ itemDetails: [], isOpenMdalDetails: true, itemSelect: item });
      }
    });
  };

  handleFiles = () => {
    if (!fileSelect) return;
    const reader = new FileReader();
    reader.onload = () => this.setState({ isCsv: true, csvData: reader.result });
    reader.readAsText(fileSelect);
  };

  onCancelUploadFile = () => {
    this.setState({ isOpenUploadFile: false, itemSelect: null });
  };

  render() {
    const {
      isSearching,
      sorted,
      page,
      size,
      totalCount,
      listOperatorTenantRecordLog,
      isOpenMdalDetails,
      itemDetails,
      itemSelect,
      sizeItem,
      pageItem,
      totalCountItem,
      isOpenMdalDownload,
      csvData,
    } = this.state;
    const { t } = this.props;

    const newTabelColumnOperatorTenantRecordLog = [
      {
        name: 'id',
        label: 'common:label.id',
        render: (colName, item) => (
          <button
            type="button"
            className="btn btn-outline-success btn-sm no-border"
            onClick={() => this.doGetTenantRecordById(item.id, item)}
          >
            {item.id}
          </button>
        ),
      },
      ...tabelColumnOperatorTenantRecordLog,
      {
        name: 'view',
        label: 'common:label.viewRecords',
        isRenderT: true,
        render: (colName, item, t) => (
          <button
            type="button"
            className="btn btn-outline-success btn-sm"
            onClick={() => this.doGetTenantRecordById(item.id, item)}
          >
            {t('label.viewRecords')}
          </button>
        ),
      },
      {
        name: 'download',
        label: 'common:label.viewFiles',
        isRenderT: true,
        render: (colName, item, t) => (
          <button
            type="button"
            className="btn btn-outline-success btn-sm"
            disabled={!item.filePath}
            onClick={() => {
              this.downloadFile(item.filePath);
              this.setState({ isOpenMdalDownload: true });
            }}
          >
            {t('label.viewFiles')}
          </button>
        ),
      },
    ];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.invoiceUsage.path}
          titleBtn="back"
          items={[{ name: t('usagePage:sidebar.operator') }, { name: t('usagePage:sidebar.tenantRecordLog') }]}
          isNoDefaultButton
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('usagePage:sidebar.tenantRecordLog')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <OperatorTenantRecordLogSearchForm onSubmit={this.onHandleSubmitSearch} />
              </div>
              <div>
                <br />
                <DataTable
                  columns={newTabelColumnOperatorTenantRecordLog}
                  data={
                    listOperatorTenantRecordLog && listOperatorTenantRecordLog.length ? listOperatorTenantRecordLog : []
                  }
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>

        <ModalWithItem
          modalTitle={t('usagePage:sidebar.tenantRecordLog')}
          isOpen={isOpenMdalDetails}
          wrapperClass="modal-custom modal-70 bd-example-modal-lg modal-selector"
          onToggle={() => {
            this.setState({ isOpenMdalDetails: false, itemDetails: [] });
          }}
        >
          <div className="col-md-12 row pb-3">
            <GenericInput
              value={itemSelect ? itemSelect.id : ''}
              wrapperClass="col-md-4"
              onChange={() => {}}
              name="fileId"
              readOnly
              label="label.fileId"
            />
            <GenericInput
              value={itemSelect ? itemSelect.fileName : ''}
              wrapperClass="col-md-4"
              onChange={() => {}}
              name="fileName"
              readOnly
              label="label.fileName"
            />
          </div>
          <DataTable
            columns={tabelColumnOperatorTenantRecordLogById}
            data={itemDetails && itemDetails.length ? itemDetails : []}
            sorted={sorted}
            isLoading={isSearching}
          />
          <br />
          <TablePagination
            pageNumber={pageItem}
            pageSize={sizeItem}
            totalCount={totalCountItem}
            onPageChange={this.onPageChangeItem}
            onSizeChange={this.onSizeChangeItem}
          />
          <div className="text-right">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                this.setState({ isOpenMdalDetails: false, itemDetails: [] });
              }}
            >
              {t('common:label.cancel')}
            </button>
          </div>
          <br />
        </ModalWithItem>
        <ModalWithItem
          modalTitle={t('usagePage:sidebar.tenantRecordLog')}
          isOpen={isOpenMdalDownload}
          onToggle={() => {
            this.setState({ isOpenMdalDownload: false });
          }}
        >
          <div className="col-md-12 d-flex p-0">
            <div>
              <button
                type="button"
                className="button x-small"
                onClick={() => {
                  this.setState({ isOpenMdalDownload: false });
                }}
              >
                {t('label.back')}
              </button>
            </div>
            <div className="group-btn-invoice text-right" style={{ width: '96%' }}>
              <button
                type="button"
                disabled={!csvData}
                className="button x-small"
                onClick={() => this.saveFileSelect()}
              >
                {t('label.download')}
              </button>
            </div>
          </div>
          <CsvToHtmlTable data={csvData} csvDelimiter="," tableClassName="table table-striped table-hover" />
        </ModalWithItem>
      </div>
    );
  }
}

TenantRecordLog.propTypes = {
  searchTenantOperatorRecord: PropTypes.func.isRequired,
  readFileFromS3: PropTypes.func.isRequired,
  getTenantRecordById: PropTypes.func.isRequired,
};

TenantRecordLog.defaultProps = {};

const mapStateToProps = createStructuredSelector({
  listOperatorTenantRecordLog: makeGetTenantOperatorRecord() || [],
  s3Config: makeGetS3Config() || {},
});
export default withTranslation('common')(
  connect(mapStateToProps, { searchTenantOperatorRecord, readFileFromS3, getTenantRecordById })(TenantRecordLog)
);
